import { Component, OnInit, Input } from '@angular/core';
import { Verb } from '../model/verb';

@Component({
  selector: 'csf-input-control',
  template: `<div class="columns">
    <div class="column col-7">
        <div class="form-group" dnd-droppable (onDropSuccess)="addVariables($event,item.key)">
            <label class="form-label" for="input-example-3">{{item.value.name}}</label>                        
            <textarea class="form-input" id="input-example-3" [(ngModel)]="node.settings[item.key]" rows="3"></textarea>
        </div>
    </div>    
    <div class="column col-5" *ngIf="i==0 && node.context!=undefined && node.context.imported!=undefined">        
        <!-- <div class="flex-input">
            <span class="flex-label"> Available Variables </span>
        </div>
        <div id="variable-list">
            <table  class="table table-sm">  
                <tbody>
                    <tr *ngFor="let varItem of node.context.imported | keyvalue">        
                        <td>
                            <div *ngFor="let variable of varItem.value.variables">
                                <div class="grab-row" dnd-draggable [dragEnabled]="true" [dragData]="variable">
                                    $<span>{{variable}}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div> -->
        <div class="flex-stack" *ngIf="variables !=undefined">    
            <div class="flex-input">
                <span class="flex-label"> Available Variables </span>
            </div>      
        </div>
        <div class="flex-stack" *ngIf="variables !=undefined">    
            <div class="flex-input">
                <!-- <span class="label-block text-muted" i18n="Send From|Send from label@@sendFromLabel">AVAILABLE VARIABLES</span> -->
                <div class="flex-row">
                    <div class="pill" *ngFor="let variable of variables">
                        <div class="grab-row" dnd-draggable [dragEnabled]="true" [dragData]="variable">
                            $<span>{{variable}}</span>
                        </div>
                    </div>
                </div>
            </div>      
        </div>
    </div>
</div>
`,
  styles: [`.grab-row{align-items:center;background:rgba(202,211,222,.4);border:1px solid rgba(0,64,133,.2);border-radius:5px;color:#004085;cursor:-webkit-grab!important;cursor:-webkit-grab!important;cursor:-moz-grab!important;display:flex;margin:.2rem auto;overflow:hidden;padding:.3rem;-webkit-user-select:none;-moz-user-select:none;transition:.4s ease-out;-ms-user-select:none;user-select:none;width:95%}.grab-row:hover{background:rgba(101,165,255,.2);color:#004085}.grab-row.dnd-drag-start,.grab-row:active{cursor:-webkit-grabbing!important;cursor:-webkit-grabbing!important;cursor:-moz-grabbing!important}.grab-row i{margin-right:5px}#variable-list{border:1px solid rgba(35,58,119,.2);border-radius:2px;max-height:150px;overflow:auto}.flex-input,.flex-input span{padding-left:0;padding-right:0}.flex-input span,.flex-label{font-size:.7rem}.table-sm td{padding:0}.droppable{padding:.3rem .5rem;font-size:.7rem}.dropped{border:1px solid #aaa;background:#fff;color:#004085;padding:5px;font-size:.75em}.dropped .close{color:#004085;font-size:11pt}.flex-row{flex-wrap:wrap}`]
})
export class InputControlComponent extends Verb implements OnInit {

  constructor() {super(); }
  //public variable:string="";
  // private _node: any;
  // @Input()
  // set node(node: any) {
  //   this._node = node; 
  // }
  // get node(): any {
  //   return this._node;     
  // }

  private _item: any;
  @Input()
  set item(item: any) {
    this._item = item; 
  }
  get item(): any {
    return this._item;     
  }

  private _i: number;
  @Input()
  set i(item: number) {
    this._i = item; 
  }
  get i(): number {
    return this._i;     
  }

  ngOnInit() {
  }

  addVariables($event: any, key:string) {
    this.node.settings[key] = this.node.settings[key] + " $" +$event.dragData;
  }

}
